import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LoadingSpinner, ErrorBoundary, ToastProvider } from './shared/components';
import { ThemeProvider } from './contexts/ThemeContext';
import { TamilFontProvider } from './contexts/TamilFontContext';
import { InspectorModalProvider } from './contexts/InspectorModalContext';

const StoryReaderPage = lazy(() => import('./features/stories/components/StoryReaderPage'));
const DemoAdminPage = lazy(() => import('./features/admin/demo/DemoAdminPage'));
const DemoLandingPage = lazy(() => import('./features/landing/DemoLandingPage'));

/**
 * Demo App - stripped down to just the story reader
 * InspectorModalProvider kept because WordPanel depends on useInspector
 */
export function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <TamilFontProvider>
          <ToastProvider>
            <InspectorModalProvider>
              <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                <Suspense fallback={<LoadingSpinner fullPage />}>
                  <Routes>
                    <Route path="/" element={<StoryReaderPage id="54" />} />
                    <Route path="/landing" element={<DemoLandingPage />} />
                    <Route path="/admin" element={<DemoAdminPage />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Suspense>
              </Router>
            </InspectorModalProvider>
          </ToastProvider>
        </TamilFontProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
